import { InputNumber } from "antd";
import React, { useEffect, useState } from "react";

const InputJumlahSoal = ({ handleChangeForm, value, maks, name }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // Menandakan bahwa komponen sudah di-mount di client
    setMounted(true);
  }, []);

  if (!mounted) return null; // Hindari render saat server-side

  return (
    <>
      <InputNumber
        className="form-control w-100"
        placeholder="0 Soal"
        name={name}
        value={typeof value === "number" ? value : 0}
        max={maks}
        min={0}
        onChange={(e) =>
          handleChangeForm(
            {
              target: {
                name: name,
                value: e,
              },
            },
            null,
            null,
            true
          )
        }
      />
      <span className="fs-14-ss fw-semibold color-secondary">
        Jumlah soal maksimal {maks}
      </span>
    </>
  );
};

export default InputJumlahSoal;
